import { ColumnMapping } from 'components/product/product-import/column-mapping/ColumnMapping'
import { useEffect, useState } from 'react'
import { Alert } from 'avo-ui'
import icAlert from 'assets/images/ic-warning.svg'
import * as Excel from 'exceljs'
import moment from 'moment'
import { formatDateMoment } from 'utils/utils'

const INITIAL_COLUMN = {
    ID: { label: 'id', value: 'id' },
    'Nama Produk': { label: 'name', value: 'name' },
    Brand: { label: 'brand', value: 'brand' },
    Kategori: { label: 'categories', value: 'categories' },
    'Tipe Produk': { label: 'types', value: 'types' },
    SKU: { label: 'sku', value: 'sku' },
    'Harga Normal': { label: 'price', value: 'price' },
    'Harga Diskon': { label: 'sale_price', value: 'sale_price' },
    'Tanggal Diskon Dimulai': { label: 'start_date_sale', value: 'start_date_sale' },
    'Tanggal Diskon Berakhir': { label: 'end_date_sale', value: 'end_date_sale' },
    Stock: { label: 'stock_quantity', value: 'stock_quantity' },
    'Berat (gram)': { label: 'weight', value: 'weight' },
    'Tinggi (cm)': { label: 'height', value: 'height' },
    'Panjang (cm)': { label: 'length', value: 'length' },
    'Lebar (cm)': { label: 'width', value: 'width' },
    Deskripsi: { label: 'description', value: 'description' },
    'How to Use': { label: 'how_to_use', value: 'how_to_use' },
    Ingredients: { label: 'ingredients', value: 'ingredients' },
}

export const ColumnMappingContainer = ({ payload, setPayloadData, onChangeStep }) => {
    const [isLoading, setIsLoading] = useState(true)
    const [columnListExcel, setColumnListExcel] = useState({})
    const [errorForm, setErrorForm] = useState({})
    const options = Object.values(INITIAL_COLUMN).map((item) => item)

    const getColumnValue = (value) => {
        let newValue
        if (moment.isDate(value)) {
            newValue = formatDateMoment(value, 'DD/MM/YYYY HH:mm:ss')
        } else if (value?.richText) {
            const getText = value?.richText?.map((item) => item?.text)
            newValue = getText?.toString()
        } else {
            newValue = value?.text || value || '-'
        }
        return newValue
    }

    useEffect(() => {
        const workbook = new Excel.Workbook()
        workbook.xlsx
            .load(payload?.file)
            .then(() => {
                const worksheet = workbook.getWorksheet()
                const dataColumn = []
                const dataExample = {}
                worksheet?.columns?.map((item) => {
                    if (item?.values[1]) {
                        dataColumn?.push({ ex_col: item?.values[1], db_col: INITIAL_COLUMN[item?.values[1]] || null })
                        dataExample[item?.values[1]] = getColumnValue(item?.values[2])
                    }
                })
                setColumnListExcel(dataExample)
                setPayloadData({ ...payload, mapping_fields: dataColumn })
                setIsLoading(false)
            })
            .catch(() => {
                onChangeStep(1)
                return Alert({
                    icon: icAlert,
                    title: 'Failed',
                    message: 'Something Wrong With File !!',
                    autoClose: true,
                    interval: 3000,
                })
            })
    }, [])

    const prevStepHandler = () => {
        onChangeStep(1)
    }

    const onChangeForm = (item) => {
        const copyMappingFields = [...payload?.mapping_fields]
        const dataMapping = copyMappingFields.map((i) => {
            if (i?.ex_col === item?.name) return { ...i, db_col: item?.value }
            return i
        })
        setPayloadData({ ...payload, mapping_fields: dataMapping })
    }

    const getValue = (key) => {
        const copyMappingFields = [...payload?.mapping_fields]
        const findData = copyMappingFields?.find((i) => i?.ex_col === key)
        return findData?.db_col
    }

    const validateForm = (dataMapping) => {
        return new Promise((resolve, reject) => {
            const errors = {}
            dataMapping.map((item) => {
                if (!item.db_col) errors[item.ex_col] = `${item.ex_col} not mapped`
            })
            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        const mapping_data = [...payload?.mapping_fields]
        validateForm(mapping_data).then(() => {
            onChangeStep(3)
        })
    }

    const props = {
        isLoading,
        columnListExcel,
        options,
        errorForm,
        prevStepHandler,
        onChangeForm,
        getValue,
        onSubmit,
    }

    return <ColumnMapping {...props} />
}
